function checkIfDuckIsInRange(duck) {
  return duck.distance > 1000;
}

export default {
  checkIfDuckIsInRange,
};
